'use strict';

import $service from '@/common/service/api-service';
import $config from '@/config';
import service from '@/common/service/index.js';

export default {
  emailModelData(context){
    context.commit('setEmailModel', []);
    $service.post('/so/email-model/list')
    .then(res => {
      if (res && res.code === 1) {
        context.commit('setEmailModel', res.data);
      } else {
        context.commit('setEmailModel', []);
      }
    });
  },
  emailSenderData(context){
    context.commit('setEmailSender', []);
    $service.post('/so/email-sender/list')
    .then(res => {
      if (res && res.code === 1) {
        context.commit('setEmailSender', res.data);
      } else {
        context.commit('setEmailSender', []);
      }
    });
  },
  emailBalanceData(context){
    $service.post('/so/send-email/balance')
    .then(res => {
      if (res && res.code === 1) {
        context.commit('setEmailBalance', res.data);
      } else {
        context.commit('setEmailBalance', {});
      }
    });
  },
  emailReportData(context, params = {}){
    $service.post('/so/send-record/paging', params)
    .then(res => {
      if (res && res.code === 1) {
        res.data.refresh=params.refresh;
        context.commit('setEmailReport', res.data);
      } else {
        context.commit('setEmailReport', {});
      }
    });
  },
  exportEmailReportData(context,args){
    return service.requestPromise('/so/send-record/paging',{
      method:'post',
      params:args
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/email/action.js